import React, { useMemo } from 'react'
import { AccountPendencyCardRow } from './components'
import { AccountPendenciesCachedData, MODAL_TYPE } from '../..'

export type AccountPendenciesCardsProps = {
  onPendencyCardClick: (modalType: MODAL_TYPE) => void,
  cachedData: AccountPendenciesCachedData
}

export const AccountPendenciesCards: React.FC<AccountPendenciesCardsProps> = (props) => {
  const { onPendencyCardClick, cachedData } = props
  const { address, socialMediaObject, phoneValidated, emailValidated } = cachedData

  const isAddressFilled = useMemo(() => {
    const { complement: _, ...rest } = address
    const currentAddress = Object.values(rest).some(item => item !== '')

    return currentAddress
  }, [address])

  const isSocialMediaFilled = useMemo(() => {
    return Object.values(socialMediaObject).some(item => item !== '')
  }, [socialMediaObject])

  return (
    <>
      <AccountPendencyCardRow
        firstCardProps={{
          title: 'Endereço Comercial',
          icon: 'LocationIcon',
          finishedText: 'Editar dados',
          description: 'Informe o endereço da sua empresa para facilitar a sua análise de crédito.',
          buttonTitle: 'Cadastrar endereço',
          onClick: () => onPendencyCardClick(MODAL_TYPE.AddressModal),
          isEditable: isAddressFilled
        }}
        secondCardProps={{
          title: 'Redes sociais',
          icon: 'AtIcon',
          isEditable: isSocialMediaFilled,
          finishedText: 'Editar dados',
          description: '(Opcional) Mostre a presença da sua empresa nas redes sociais.',
          buttonTitle: 'Cadastrar redes sociais',
          onClick: () => onPendencyCardClick(MODAL_TYPE.SocialNetworkInfoModal)
        }}
        rowTitle='Informações adicionais da sua empresa'
      />
      <AccountPendencyCardRow
        firstCardProps={{
          title: 'Validação de e-mail',
          icon: 'LocationIcon',
          isFinished: emailValidated,
          finishedText: 'E-mail validado',
          description: 'Clique no botão abaixo para validar o seu e-mail e efetivar o seu cadastro.',
          buttonTitle: 'Validar e-mail',
          onClick: () => onPendencyCardClick(MODAL_TYPE.ValidateEmailModal)
        }}
        secondCardProps={{
          title: 'Validação de celular',
          icon: 'DeviceIcon',
          isFinished: phoneValidated,
          finishedText: 'Celular validado',
          description: 'Clique no botão abaixo para validar o seu celular e efetivar o seu cadastro.',
          buttonTitle: 'Validar celular',
          onClick: () => onPendencyCardClick(MODAL_TYPE.ValidatePhoneModal)
        }}
        rowTitle='Validação de e-mail e celular'
      />
    </>
  )
}
